module.exports = __webpack_public_path__ + "assets/images/green-xmas-1.jpg?v=093d00b4";